import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { ITemplate } from 'entities/template/template';
import { deleteTemplate } from '../sections/template-list/utils/queries';
import { useTemplatesListDispatch } from '../sections/template-list/context/UseTemplatesListContext';
import useNotifications from 'core/notifications/useNotifications';
import { getQueryKeysToInvalidate } from '../sections/template-list/utils/getQueryKeysToInvalidate';
import { invalidateTemplateQueries } from '../sections/template-list/utils/invalidateTemplateQueries';

export function useDeleteTemplate(selectedTemplate: ITemplate) {
  const { t } = useTranslation(['common', 'designs', 'supportedLanguages', 'templates']);
  const { showNotification } = useNotifications();
  const queryClient = useQueryClient();
  const dispatch = useTemplatesListDispatch();

  return useMutation(
    () =>
      deleteTemplate({
        siteId: selectedTemplate.siteId,
        templateId: selectedTemplate.id,
        channel: selectedTemplate.channel,
        campaignType: selectedTemplate.type,
        t,
      }),
    {
      onSuccess: () => {
        showNotification(t('designs:designGallery.form.comment.notifications.deleteTemplateSuccess'), 'normal');
        invalidateTemplateQueries(queryClient, selectedTemplate, getQueryKeysToInvalidate(selectedTemplate));
        dispatch({ type: 'RESET_SELECTED_TEMPLATE' });
      },
      onError: (error: unknown) => {
        dispatch({ type: 'RESET_SELECTED_TEMPLATE' });
        const errorObj = error as { response?: { data?: { message?: string } }; message?: string };
        const errorMessage =
          errorObj?.response?.data?.message ||
          errorObj?.message ||
          t('designs:designGallery.form.comment.notifications.deleteTemplateError');
        showNotification(errorMessage, 'error');
      },
    },
  );
}
